import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconNext: React.FC = () => (
    <Icon viewBox="0 0 24 24" fill="none">
        <line
            x1="0.75"
            y1="12"
            x2="23.25"
            y2="12"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5px"
        />
        <polyline
            points="12.75 22.5 23.25 12 12.75 1.5"
            fillRule="evenodd"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5px"
        />
    </Icon>
);
